import { SpecialButton } from '@chegg-wt/core/theme/fanta/button'
import styled from 'styled-components'

export const CreateCitationButton = styled(SpecialButton)`
  border: 2px solid ${({ theme }) => theme.Colors.primaryColor};
`
